export type VisitorPaymentMode = "direct" | "annual_settlement";

export interface VisitorRegistration {
  id: string;
  contract_id: string;
  visit_date: string;
  adults: number;
  children: number;
  extra_cars: number;
  payment_mode: VisitorPaymentMode;
  invoice_id: string | null;
  subtotal: string;
  total_amount: string;
  notes: string | null;
  created_at: string;
  guest_name?: string | null;
  pitch_code?: string | null;
  invoice_number?: string | null;
}

export interface VisitorPriceLine {
  rule_type: string;
  article_id: string;
  article_number: string;
  article_name: string;
  quantity: string;
  unit_price: string;
  line_subtotal: string;
  tax_rate_percent: string;
  tax_amount: string;
  line_total: string;
}

export interface VisitorPriceQuote {
  lines: VisitorPriceLine[];
  subtotal: string;
  tax_amount: string;
  total: string;
}

export interface VisitorRegistrationCreatePayload {
  contract_id: string;
  visit_date: string;
  adults: number;
  children: number;
  extra_cars: number;
  payment_mode: VisitorPaymentMode;
  notes?: string | null;
  collect_payment?: boolean;
  payment_method?: "cash" | "card" | null;
}

export const VISITOR_PAYMENT_MODE_OPTIONS: {
  value: VisitorPaymentMode;
  label: string;
  description: string;
}[] = [
  {
    value: "direct",
    label: "Sofort bezahlen",
    description: "Rechnung wird ausgestellt und kann direkt kassiert werden.",
  },
  {
    value: "annual_settlement",
    label: "Jahresendabrechnung",
    description: "Gebühren werden auf den Jahresendabrechnungs-Entwurf des Vertrags gebucht.",
  },
];

export function visitorPaymentModeLabel(mode: VisitorPaymentMode): string {
  return VISITOR_PAYMENT_MODE_OPTIONS.find((o) => o.value === mode)?.label ?? mode;
}
